"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.observeBounds = void 0;
var handle_1 = require("./handle");
/**
 * Observe changes to the bounding client rect of an element using a best-effort approach.
 *
 * @returns a handle that allows canceling the observation
 */
function observeBounds(element, callback) {
    var previousBounds = element.getBoundingClientRect();
    var process = function () {
        var newBounds = element.getBoundingClientRect();
        if (!rectEquals(newBounds, previousBounds)) {
            callback({
                previousBounds: previousBounds,
                newBounds: newBounds,
            });
            previousBounds = newBounds;
        }
    };
    var mutationObserver = new MutationObserver(process);
    var resizeObserver = new ResizeObserver(process);
    return handle_1.HandleUtils.combine({
        cancel: function () {
            mutationObserver.disconnect();
            resizeObserver.disconnect();
        }
    }, observeLayout(element, mutationObserver, resizeObserver, process));
}
exports.observeBounds = observeBounds;
/**
 * Observe layout changes that could potentially affect the given element's bounds.
 * This function sets up observation for style changes, parent's size changes, scroll events, and recursively observes
 * ancestors for layout changes as well.
 *
 * @return a handle that can be used to cancel the observation.
 */
function observeLayout(element, mutationObserver, resizeObserver, callback) {
    // Observe style changes, which are one of very important triggers of layout changes
    mutationObserver.observe(element, {
        attributes: true,
        attributeFilter: ['style', 'class'],
    });
    var parent = element.parentElement;
    if (!parent) {
        return {
            cancel: function () {
            }
        };
    }
    // Parent's size reflects most changes of the siblings' layout, so let's observe it
    resizeObserver.observe(parent);
    return handle_1.HandleUtils.combine(
    // Observe scroll events, as scrolling affects element's bounds
    observeScroll(parent, callback), 
    // Recurse
    observeLayout(parent, mutationObserver, resizeObserver, callback));
}
function observeScroll(element, callback) {
    element.addEventListener('scroll', callback, {
        passive: true,
    });
    return {
        cancel: function () {
            element.removeEventListener('scroll', callback);
        }
    };
}
function rectEquals(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
//# sourceMappingURL=observeBounds.js.map